export const CaretRightIcon = () => (
  <svg className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth={4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
